<template>
  <div class="page-loader" :class="{ 'fade-out': isloaded }">
    <div class="teste">
    <img src="../../assets/Loader/GIF-FIBRILLARE.gif" alt="Loader GIF">
    </div>
  </div>
</template>

<script>
export default {
  name: "PageLoader",
  data: () => ({
    isloaded: false,
  }),
  mounted() {
    // DELAYZINHO DE CRIA
    setTimeout(() => {
      this.isloaded = true;
    }, );
  } 
};
</script>

<style lang="scss" scoped>
.page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fbfbfb;
  z-index: 999;
  opacity: 1;
  transition: opacity 0.8s ease, visibility 0s 0.8s; /* DURAÇÃO DO FADE */
}

.page-loader.fade-out {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.8s ease, visibility 0s 0.8s;
}

.teste {
  width: 100vh;
}


</style>
